import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import DepositStepTwo from "./DepositStepTwo";
import SelectMethod from "./components/SelectMethod";
import DepositStepOne from "./DepositStepOne";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import LoadingBlock from "../../components/Loading/LoadingBlock";
import DetailWrapper from "../../components/detailWrapper";
import { useTranslation } from "react-i18next";
import { getDepositPaymentList } from "../../api/getApi";
import useSpecPath from "../../hook/useSpecPath";

const Deposit = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`deposit.${key}`);

  const memberData = useSelector((state) => state.isMemberInfo);

  const navigate = useNavigate();

  const [chooseCurrency, setChooseCurrency] = useState("PHP");
  const [depositStep, setDepositStep] = useState(1);
  const [depositMethod, setDepositMethod] = useState([]);
  const [paymentList, setPaymentList] = useState({
    payments: [],
    paymentData: {},
    cryptoPayments: {},
  });
  const { payments, paymentData, cryptoPayments } = paymentList;
  const [isLoading, setIsLoading] = useState(false);

  const getSpecPath = useSpecPath({ specPath: "deposit" });

  useEffect(() => {
    setIsLoading(true);

    getDepositPaymentList()
      .then((data) => {
        const paymentData = data.deposit;
        const payments = Object.keys(paymentData).filter(
          (item) => item !== "crypto"
        );
        const cryptoPayments = data.deposit?.crypto?.list;

        setPaymentList({
          payments,
          paymentData,
          cryptoPayments,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  return (
    <DetailWrapper>
      <>
        {depositStep === 1 && (
          <>
            <DepositStepOne
              setDepositStep={setDepositStep}
              setChooseCurrency={setChooseCurrency}
              depositStep={depositStep}
              depositMethod={payments}
              cryptoPayments={cryptoPayments}
              paymentData={paymentData}
              isLoading={isLoading}
            />

            <p
              onClick={() => {
                navigate(`${getSpecPath}withdraw`);
              }}
              className="text-center my-[10px] underline text-light-text cursor-pointer"
            >
              {i18n("withdraw")}
            </p>
          </>
        )}
        {depositStep === 2 && (
          <DepositStepTwo
            paymentData={paymentData}
            setDepositStep={setDepositStep}
            chooseCurrency={chooseCurrency}
            depositStep={depositStep}
          />
        )}
      </>
    </DetailWrapper>
  );
};

export default Deposit;
